
define('template!adminApiStatsListTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="admin-api-stats">\n  ';
 if (checking) { ;
__p += '\n    <div class="state-box"><i class="fa fa-spinner fa-spin"></i></div>\n  ';
 } else if (!canView) { ;
__p += '\n    <div class="state-box">\n      <i class="fa fa-lock"></i>\n      <p>' +
((__t = ( _.i18n('admin.apiStats.notAuthorized', null, 'This screen is reserved for the DEV TEAM group.') )) == null ? '' : __t) +
'</p>\n    </div>\n  ';
 } else { ;
__p += '\n\n  <header class="page-header">\n    <h2>\n      <i class="fa fa-bar-chart"></i> ' +
((__t = ( _.i18n('admin.apiStats.title', null, 'API statistics') )) == null ? '' : __t) +
'\n      ';
 if (loading && mode !== 'block') { ;
__p += '<i class="fa fa-spinner fa-spin loading-icon"></i>';
 } ;
__p += '\n    </h2>\n    <div class="filters">\n      <div class="presets mode-switch">\n        <button type="button" class="js-mode preset-btn ' +
__e( mode === 'api' ? 'active' : '' ) +
'" data-mode="api"><i class="fa fa-plug"></i> ' +
((__t = ( _.i18n('admin.apiStats.modeApi', null, 'API calls') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-mode preset-btn ' +
__e( mode === 'notifications' ? 'active' : '' ) +
'" data-mode="notifications"><i class="fa fa-bell"></i> ' +
((__t = ( _.i18n('admin.apiStats.modeNotifications', null, 'Notifications') )) == null ? '' : __t) +
'</button>\n        ';
 if (canBlock) { ;
__p += '\n          <button type="button" class="js-mode preset-btn ' +
__e( mode === 'block' ? 'active' : '' ) +
'" data-mode="block"><i class="fa fa-ban"></i> ' +
((__t = ( _.i18n('admin.apiStats.modeBlocking', null, 'Blocking') )) == null ? '' : __t) +
'</button>\n        ';
 } ;
__p += '\n      </div>\n      ';
 if (mode !== 'block') { ;
__p += '\n      <div class="presets">\n        <button type="button" class="js-preset preset-btn ' +
__e( preset === '24h' ? 'active' : '' ) +
'" data-preset="24h">' +
((__t = ( _.i18n('admin.apiStats.last24h', null, '24 h') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-preset preset-btn ' +
__e( preset === 'today' ? 'active' : '' ) +
'" data-preset="today">' +
((__t = ( _.i18n('admin.apiStats.today', null, 'Today') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-preset preset-btn ' +
__e( preset === '7d' ? 'active' : '' ) +
'" data-preset="7d">' +
((__t = ( _.i18n('admin.apiStats.last7d', null, '7 days') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-preset preset-btn ' +
__e( preset === '30d' ? 'active' : '' ) +
'" data-preset="30d">' +
((__t = ( _.i18n('admin.apiStats.last30d', null, '30 days') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-preset preset-btn ' +
__e( preset === '90d' ? 'active' : '' ) +
'" data-preset="90d">' +
((__t = ( _.i18n('admin.apiStats.last90d', null, '90 days') )) == null ? '' : __t) +
'</button>\n      </div>\n      <div class="range">\n        <input type="date" class="js-from" value="' +
__e( fromValue ) +
'" aria-label="From" />\n        <span class="dash">&mdash;</span>\n        <input type="date" class="js-to" value="' +
__e( toValue ) +
'" aria-label="To" />\n        <button type="button" class="btn btn-primary js-apply">' +
((__t = ( _.i18n('common.apply', null, 'Apply') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="btn btn-default js-refresh" title="' +
__e( _.i18n('common.refresh', null, 'Refresh') ) +
'"><i class="fa fa-refresh"></i></button>\n      </div>\n      ';
 } ;
__p += '\n    </div>\n  </header>\n\n  ';
 if (mode === 'block') { ;
__p += '\n    <div class="js-block-container"></div>\n  ';
 } else { ;
__p += '\n\n  <div class="chips">\n    ';
 if (!allAccounts) { ;
__p += '\n      <span class="scope-note"><i class="fa fa-info-circle"></i> ' +
((__t = ( _.i18n('admin.apiStats.ownAccountOnly', null, 'Your account only') )) == null ? '' : __t) +
'</span>\n    ';
 } ;
__p += '\n    ';
 _.each(chips, function (chip) { ;
__p += '\n      <span class="chip">\n        <i class="fa ' +
__e( chip.icon ) +
'"></i> ' +
__e( chip.label ) +
'\n        <button type="button" class="js-clear-filter chip-clear" data-key="' +
__e( chip.key ) +
'" aria-label="Remove filter">&times;</button>\n      </span>\n    ';
 }); ;
__p += '\n    ';
 if (!chips.length && mode === 'notifications') { ;
__p += '\n      <span class="hint">' +
((__t = ( _.i18n('admin.apiStats.notificationDrillHint', null, 'Notifications pushed by the backend to the dashboards. Click a row to drill down: account / type → sources → triggers') )) == null ? '' : __t) +
'</span>\n    ';
 } else if (!chips.length && allAccounts) { ;
__p += '\n      <span class="hint">' +
((__t = ( _.i18n('admin.apiStats.drillHint', null, 'Click a row to drill down: account → users → endpoints, client → users, host → origins → users') )) == null ? '' : __t) +
'</span>\n    ';
 } ;
__p += '\n  </div>\n\n  ';
 if (error) { ;
__p += '\n    <div class="error-box"><i class="fa fa-exclamation-triangle"></i> ' +
((__t = ( _.i18n('admin.apiStats.loadError', null, 'Statistics could not be loaded.') )) == null ? '' : __t) +
'</div>\n  ';
 } ;
__p += '\n\n  ';
 if (mode === 'notifications') { ;
__p += '\n  <section class="kpis">\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.calls ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.sends', null, 'Notifications sent') )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.errorRate ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.failures', null, 'Failures') )) == null ? '' : __t) +
' · ' +
__e( kpis.errors ) +
'</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.avgMs ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.avgDuration', null, 'Avg duration') )) == null ? '' : __t) +
' · max ' +
__e( kpis.maxMs ) +
'</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.bytes ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.dataSent', null, 'Data sent') )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.sources ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.sources', null, 'Sources') )) == null ? '' : __t) +
' · ' +
__e( kpis.accounts ) +
' ' +
((__t = ( _.i18n('admin.apiStats.accountsLower', null, 'accounts') )) == null ? '' : __t) +
' · ' +
__e( kpis.types ) +
' ' +
((__t = ( _.i18n('admin.apiStats.typesLower', null, 'types') )) == null ? '' : __t) +
'</div>\n    </div>\n  </section>\n  ';
 } else { ;
__p += '\n  <section class="kpis">\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.calls ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.calls', null, 'Calls') )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.errorRate ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.errorRate', null, 'Errors') )) == null ? '' : __t) +
' · ' +
__e( kpis.errors ) +
' (' +
__e( kpis.serverErrors ) +
' 5xx)</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.avgMs ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.avgDuration', null, 'Avg duration') )) == null ? '' : __t) +
' · max ' +
__e( kpis.maxMs ) +
'</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.users ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.usersAccounts', null, 'Users') )) == null ? '' : __t) +
' · ' +
__e( kpis.accounts ) +
' ' +
((__t = ( _.i18n('admin.apiStats.accountsLower', null, 'accounts') )) == null ? '' : __t) +
'</div>\n    </div>\n    <div class="kpi">\n      <div class="kpi-value">' +
__e( kpis.endpoints ) +
'</div>\n      <div class="kpi-label">' +
((__t = ( _.i18n('admin.apiStats.endpoints', null, 'Endpoints') )) == null ? '' : __t) +
' · ' +
__e( kpis.clients ) +
' ' +
((__t = ( _.i18n('admin.apiStats.clientsLower', null, 'clients') )) == null ? '' : __t) +
'</div>\n    </div>\n  </section>\n  ';
 } ;
__p += '\n\n  <section class="panel timeline-panel">\n    <header class="panel-header">\n      <h3>';
 if (mode === 'notifications') { ;
__p +=
((__t = ( hourly ? _.i18n('admin.apiStats.sendsPerHour', null, 'Notifications per hour') : _.i18n('admin.apiStats.sendsPerDay', null, 'Notifications per day') )) == null ? '' : __t);
 } else { ;
__p +=
((__t = ( hourly ? _.i18n('admin.apiStats.callsPerHour', null, 'Calls per hour') : _.i18n('admin.apiStats.callsPerDay', null, 'Calls per day') )) == null ? '' : __t);
 } ;
__p += '</h3>\n      <div class="legend">\n        <span class="legend-item"><span class="swatch swatch-ok"></span>' +
((__t = ( _.i18n('admin.apiStats.successful', null, 'Successful') )) == null ? '' : __t) +
'</span>\n        <span class="legend-item"><span class="swatch swatch-err"></span>' +
((__t = ( mode === 'notifications' ? _.i18n('admin.apiStats.failures', null, 'Failures') : _.i18n('admin.apiStats.errorsLegend', null, 'Errors (4xx / 5xx)') )) == null ? '' : __t) +
'</span>\n      </div>\n    </header>\n    ';
 if (!axis) { ;
__p += '\n      <div class="empty">' +
((__t = ( _.i18n('admin.apiStats.noData', null, 'No calls for this period') )) == null ? '' : __t) +
'</div>\n    ';
 } else { ;
__p += '\n    <div class="chart-wrap">\n      <div class="y-axis">\n        <span>' +
__e( axis.max ) +
'</span>\n        <span>' +
__e( axis.half ) +
'</span>\n        <span>0</span>\n      </div>\n      <div class="chart js-chart">\n        <div class="grid-line" style="top: 0"></div>\n        <div class="grid-line" style="top: 50%"></div>\n        <div class="bars">\n          ';
 _.each(bars, function (bar, i) { ;
__p += '\n            <div class="bar js-bar" data-index="' +
__e( i ) +
'">\n              <div class="bar-stack">\n                ';
 if (bar.errPct > 0) { ;
__p += '<div class="seg seg-err" style="height: ' +
__e( bar.errPct ) +
'%"></div>';
 } ;
__p += '\n                ';
 if (bar.okPct > 0) { ;
__p += '<div class="seg seg-ok" style="height: ' +
__e( bar.okPct ) +
'%"></div>';
 } ;
__p += '\n              </div>\n            </div>\n          ';
 }); ;
__p += '\n        </div>\n        <div class="tooltip-box js-tooltip"></div>\n      </div>\n    </div>\n    <div class="x-axis"><span>' +
__e( axis.first ) +
'</span><span>' +
__e( axis.last ) +
'</span></div>\n    ';
 } ;
__p += '\n  </section>\n\n  <section class="panel breakdown-panel">\n    <header class="panel-header">\n      <div class="tabs">\n        ';
 if (mode === 'notifications') { ;
__p += '\n          ';
 if (allAccounts) { ;
__p += '\n            <button type="button" class="js-tab tab ' +
__e( tab === 'accounts' ? 'active' : '' ) +
'" data-tab="accounts"><i class="fa fa-building"></i> ' +
((__t = ( _.i18n('admin.apiStats.accounts', null, 'Accounts') )) == null ? '' : __t) +
'</button>\n          ';
 } ;
__p += '\n          <button type="button" class="js-tab tab ' +
__e( tab === 'types' ? 'active' : '' ) +
'" data-tab="types"><i class="fa fa-tag"></i> ' +
((__t = ( _.i18n('admin.apiStats.types', null, 'Types') )) == null ? '' : __t) +
'</button>\n          <button type="button" class="js-tab tab ' +
__e( tab === 'sources' ? 'active' : '' ) +
'" data-tab="sources"><i class="fa fa-code"></i> ' +
((__t = ( _.i18n('admin.apiStats.sources', null, 'Sources') )) == null ? '' : __t) +
'</button>\n          <button type="button" class="js-tab tab ' +
__e( tab === 'triggers' ? 'active' : '' ) +
'" data-tab="triggers"><i class="fa fa-bolt"></i> ' +
((__t = ( _.i18n('admin.apiStats.triggers', null, 'Triggers') )) == null ? '' : __t) +
'</button>\n        ';
 } else { ;
__p += '\n        ';
 if (allAccounts) { ;
__p += '\n          <button type="button" class="js-tab tab ' +
__e( tab === 'accounts' ? 'active' : '' ) +
'" data-tab="accounts"><i class="fa fa-building"></i> ' +
((__t = ( _.i18n('admin.apiStats.accounts', null, 'Accounts') )) == null ? '' : __t) +
'</button>\n        ';
 } ;
__p += '\n        <button type="button" class="js-tab tab ' +
__e( tab === 'users' ? 'active' : '' ) +
'" data-tab="users"><i class="fa fa-user"></i> ' +
((__t = ( _.i18n('admin.apiStats.users', null, 'Users') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-tab tab ' +
__e( tab === 'endpoints' ? 'active' : '' ) +
'" data-tab="endpoints"><i class="fa fa-plug"></i> ' +
((__t = ( _.i18n('admin.apiStats.endpoints', null, 'Endpoints') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-tab tab ' +
__e( tab === 'clients' ? 'active' : '' ) +
'" data-tab="clients"><i class="fa fa-desktop"></i> ' +
((__t = ( _.i18n('admin.apiStats.clients', null, 'Clients') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-tab tab ' +
__e( tab === 'hosts' ? 'active' : '' ) +
'" data-tab="hosts"><i class="fa fa-server"></i> ' +
((__t = ( _.i18n('admin.apiStats.hosts', null, 'Hosts') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-tab tab ' +
__e( tab === 'origins' ? 'active' : '' ) +
'" data-tab="origins"><i class="fa fa-globe"></i> ' +
((__t = ( _.i18n('admin.apiStats.origins', null, 'Origins') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="js-tab tab ' +
__e( tab === 'apps' ? 'active' : '' ) +
'" data-tab="apps"><i class="fa fa-cubes"></i> ' +
((__t = ( _.i18n('admin.apiStats.apps', null, 'Apps') )) == null ? '' : __t) +
'</button>\n        ';
 } ;
__p += '\n      </div>\n      <label class="sort">\n        ' +
((__t = ( _.i18n('admin.apiStats.sortBy', null, 'Sort by') )) == null ? '' : __t) +
'\n        <select class="js-sort">\n          <option value="CALLS" ' +
__e( sort === 'CALLS' ? 'selected' : '' ) +
'>' +
((__t = ( _.i18n('admin.apiStats.calls', null, 'Calls') )) == null ? '' : __t) +
'</option>\n          <option value="ERRORS" ' +
__e( sort === 'ERRORS' ? 'selected' : '' ) +
'>' +
((__t = ( _.i18n('admin.apiStats.errors', null, 'Errors') )) == null ? '' : __t) +
'</option>\n          <option value="AVG_MS" ' +
__e( sort === 'AVG_MS' ? 'selected' : '' ) +
'>' +
((__t = ( _.i18n('admin.apiStats.avgDuration', null, 'Avg duration') )) == null ? '' : __t) +
'</option>\n          <option value="MAX_MS" ' +
__e( sort === 'MAX_MS' ? 'selected' : '' ) +
'>' +
((__t = ( _.i18n('admin.apiStats.maxDuration', null, 'Max duration') )) == null ? '' : __t) +
'</option>\n          <option value="TOTAL_MS" ' +
__e( sort === 'TOTAL_MS' ? 'selected' : '' ) +
'>' +
((__t = ( _.i18n('admin.apiStats.totalTime', null, 'Total server time') )) == null ? '' : __t) +
'</option>\n          ';
 if (mode === 'notifications') { ;
__p += '<option value="BYTES" ' +
__e( sort === 'BYTES' ? 'selected' : '' ) +
'>' +
((__t = ( _.i18n('admin.apiStats.dataSent', null, 'Data sent') )) == null ? '' : __t) +
'</option>';
 } ;
__p += '\n        </select>\n      </label>\n    </header>\n\n    ';
 if (!rows.length) { ;
__p += '\n      <div class="empty">' +
((__t = ( _.i18n('admin.apiStats.noData', null, 'No calls for this period') )) == null ? '' : __t) +
'</div>\n    ';
 } else { ;
__p += '\n    <div class="table-scroll">\n    <table class="stats-table">\n      <thead>\n        ';
 if (mode === 'notifications') { ;
__p += '\n        <tr>\n          <th class="rank">#</th>\n          <th>' +
((__t = ( tab === 'accounts' ? _.i18n('admin.apiStats.account', null, 'Account') : (tab === 'types' ? _.i18n('admin.apiStats.type', null, 'Type') : (tab === 'sources' ? _.i18n('admin.apiStats.source', null, 'Source') : _.i18n('admin.apiStats.trigger', null, 'Trigger'))) )) == null ? '' : __t) +
'</th>\n          <th class="num">' +
((__t = ( _.i18n('admin.apiStats.sent', null, 'Sent') )) == null ? '' : __t) +
'</th>\n          <th class="bar-col"></th>\n          <th class="num">' +
((__t = ( _.i18n('admin.apiStats.failures', null, 'Failures') )) == null ? '' : __t) +
'</th>\n          <th class="num">' +
((__t = ( _.i18n('admin.apiStats.avg', null, 'Avg') )) == null ? '' : __t) +
'</th>\n          <th class="num">' +
((__t = ( _.i18n('admin.apiStats.max', null, 'Max') )) == null ? '' : __t) +
'</th>\n          <th class="num">' +
((__t = ( _.i18n('admin.apiStats.data', null, 'Data') )) == null ? '' : __t) +
'</th>\n          <th class="num">' +
((__t = ( tab === 'sources' ? _.i18n('admin.apiStats.triggers', null, 'Triggers') : _.i18n('admin.apiStats.sources', null, 'Sources') )) == null ? '' : __t) +
'</th>\n        </tr>\n        ';
 } else { ;
__p += '\n        <tr>\n          <th class="rank">#</th>\n          <th>' +
((__t = ( tab === 'accounts' ? _.i18n('admin.apiStats.account', null, 'Account') : (tab === 'users' ? _.i18n('admin.apiStats.user', null, 'User') : (tab === 'clients' ? _.i18n('admin.apiStats.client', null, 'Client') : (tab === 'hosts' ? _.i18n('admin.apiStats.host', null, 'Host') : (tab === 'origins' ? _.i18n('admin.apiStats.origin', null, 'Origin') : (tab === 'apps' ? _.i18n('admin.apiStats.app', null, 'App') : _.i18n('admin.apiStats.endpoint', null, 'Endpoint')))))) )) == null ? '' : __t) +
'</th>\n          <th class="num">' +
((__t = ( _.i18n('admin.apiStats.calls', null, 'Calls') )) == null ? '' : __t) +
'</th>\n          <th class="bar-col"></th>\n          <th class="num">' +
((__t = ( _.i18n('admin.apiStats.errors', null, 'Errors') )) == null ? '' : __t) +
'</th>\n          <th class="num">' +
((__t = ( _.i18n('admin.apiStats.avg', null, 'Avg') )) == null ? '' : __t) +
'</th>\n          <th class="num">' +
((__t = ( _.i18n('admin.apiStats.max', null, 'Max') )) == null ? '' : __t) +
'</th>\n          ';
 if (tab === 'accounts') { ;
__p += '<th class="num">' +
((__t = ( _.i18n('admin.apiStats.users', null, 'Users') )) == null ? '' : __t) +
'</th>';
 } ;
__p += '\n          ';
 if (tab === 'endpoints' || tab === 'clients' || tab === 'hosts' || tab === 'origins' || tab === 'apps') { ;
__p += '<th class="num">' +
((__t = ( _.i18n('admin.apiStats.accounts', null, 'Accounts') )) == null ? '' : __t) +
'</th><th class="num">' +
((__t = ( _.i18n('admin.apiStats.users', null, 'Users') )) == null ? '' : __t) +
'</th>';
 } ;
__p += '\n          ';
 if (tab === 'accounts' || tab === 'users') { ;
__p += '<th class="num">' +
((__t = ( _.i18n('admin.apiStats.endpoints', null, 'Endpoints') )) == null ? '' : __t) +
'</th><th class="num">' +
((__t = ( _.i18n('admin.apiStats.clients', null, 'Clients') )) == null ? '' : __t) +
'</th>';
 } ;
__p += '\n        </tr>\n        ';
 } ;
__p += '\n      </thead>\n      <tbody>\n      ';
 _.each(rows, function (row, idx) { ;
__p += '\n        <tr class="js-row" data-index="' +
__e( idx ) +
'">\n          <td class="rank">' +
__e( idx + 1 ) +
'</td>\n          <td class="name-cell">\n            ';
 if (mode === 'api' && tab === 'endpoints') { ;
__p += '\n              <span class="method method-' +
__e( (row.httpMethod || '').toLowerCase() ) +
'">' +
__e( row.httpMethod ) +
'</span>\n              <span class="endpoint" title="' +
__e( row.endpoint ) +
'">' +
__e( row.endpoint ) +
'</span>\n            ';
 } else { ;
__p += '\n              <span class="row-title">' +
__e( row.title ) +
'</span>\n              ';
 if (row.subtitle) { ;
__p += '<span class="row-sub">' +
__e( row.subtitle ) +
'</span>';
 } ;
__p += '\n            ';
 } ;
__p += '\n          </td>\n          <td class="num"><strong>' +
__e( row.callsLabel ) +
'</strong></td>\n          <td class="bar-col"><div class="bar-track"><div class="bar-fill" style="width: ' +
__e( row.barPct ) +
'%"></div></div></td>\n          <td class="num ' +
__e( row.hasServerErrors ? 'has-5xx' : '' ) +
'" title="' +
__e( row.errorTitle ) +
'">';
 if (row.hasServerErrors) { ;
__p += '<i class="fa fa-exclamation-circle" aria-label="5xx"></i> ';
 } ;
__p +=
__e( row.errorsLabel ) +
'</td>\n          <td class="num">' +
__e( row.avgLabel ) +
'</td>\n          <td class="num">' +
__e( row.maxLabel ) +
'</td>\n          ';
 if (mode === 'notifications') { ;
__p += '\n          <td class="num">' +
__e( row.bytesLabel ) +
'</td>\n          <td class="num">' +
__e( tab === 'sources' ? row.triggersLabel : row.sourcesLabel ) +
'</td>\n          ';
 } else { ;
__p += '\n          ';
 if (tab === 'accounts') { ;
__p += '<td class="num">' +
__e( row.usersLabel ) +
'</td>';
 } ;
__p += '\n          ';
 if (tab === 'endpoints' || tab === 'clients' || tab === 'hosts' || tab === 'origins' || tab === 'apps') { ;
__p += '<td class="num">' +
__e( row.accountsLabel ) +
'</td><td class="num">' +
__e( row.usersLabel ) +
'</td>';
 } ;
__p += '\n          ';
 if (tab === 'accounts' || tab === 'users') { ;
__p += '<td class="num">' +
__e( row.endpointsLabel ) +
'</td><td class="num">' +
__e( row.clientsLabel ) +
'</td>';
 } ;
__p += '\n          ';
 } ;
__p += '\n        </tr>\n      ';
 }); ;
__p += '\n      </tbody>\n    </table>\n    </div>\n    ';
 } ;
__p += '\n  </section>\n\n  ';
 } ;
__p += '\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

